import React from 'react';
import { Image, View } from 'react-native';

import { Text } from 'react-native-web';
import { Android, iMessage } from '../../../utils/DictionaryManagementUtils';
import LargeBtnWithFilling from '../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import { getRef, xlateText } from '../../../utils/Utils';
import SelectColorStepPoint from '../AuxiliaryComponent/MixComponent/SelectColorStepPoint';
import { textPrimary_13_9, textPrimary_9_2 } from '../AuxiliaryComponent/TextComponent/TextStyle';
import { img_scr_status_Bar_Ios } from '../../../utils/ImagesManagementUtils';
//= ========================================================================

const FullPageSpecialSimulator = ({
  children,
  globJSON,
  simPlatform,
  TopTitle,
  WithImageBackground,
  LabelInputText,
  numOfPointThatGetColor,
  withStatusBar,
  slideshowRefs = null,

}) => {
  const imageHeight = simPlatform === Android ? 427 : 540;
  const { colors } = globJSON.configurations.theme;
  const { promotion } = globJSON.configurations.onboarding;

  const myStyles = {
    container: {
      marginTop: 20,
      alignSelf: 'center',
      width: 240,
    },
    insidePhoneScreen: {
      marginTop: 20,
      overflow: 'hidden',
      width: '100%',
      height: simPlatform === iMessage ? 470 : imageHeight,
      position: 'absolute',
    },
    phoneImage: {
      width: 240,
      height: simPlatform === iMessage ? 470 : imageHeight,
      backgroundColor: colors.app_background_color,
      position: 'absolute',
    },
    title: {
      height: 20,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 16,
      marginTop: -20,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: colors.primary_font_color,
      position: 'absolute',
      zIndex: 1,
    },
    lblTitle: {
      width: 200,
      marginTop: simPlatform === Android ? 258 : 300,
      textAlign: 'center',
      alignSelf: 'center',
      zIndex: 1,
    },
    lblBottomLine: {
      width: 86,
      height: 3.2,
      marginLeft: 77,
      marginTop: 10,
      borderRadius: 1.6,
      backgroundColor: colors.primary_font_color,
    },
    largeBtn: {
      marginTop: 40,
    },
    lblMaybeLater: {
      marginTop: simPlatform === Android ? 10 : 15,
      zIndex: 1,
      textAlign: 'center',
      alignSelf: 'center',
    },
    scr_status_Bar_Ios_Style: {
      width: '100%',
      height: 20,
    },
    imageStatusBar: {
      position: 'absolute',
      width: '100%',
    },
    marginTop: {
      marginTop: 40,
    },
  };
  return (
    <View style={myStyles.container} ref={getRef(slideshowRefs)}>
      {TopTitle && <Text style={myStyles.title}>{TopTitle}</Text>}
      <Image
        fadeDuration={0}
        style={myStyles.phoneImage}
        source={WithImageBackground}
      />
      <View style={myStyles.insidePhoneScreen}>
        {children}
      </View>
      <Text
        numberOfLines={2}
        ellipsizeMode="tail"
        style={[textPrimary_13_9(globJSON, simPlatform), myStyles.lblTitle]}
      >
        {LabelInputText}
      </Text>
      <SelectColorStepPoint
        globJSON={globJSON}
        simPlatform={simPlatform}
        numOfPointThatGetColor={numOfPointThatGetColor}
      />
      <View style={myStyles.marginTop}>
        <LargeBtnWithFilling
          globJSON={globJSON}
          simPlatform={simPlatform}
          inputText={xlateText(promotion.o_a_button_title, globJSON)}
        />
      </View>
      <Text style={[textPrimary_9_2(globJSON, simPlatform), myStyles.lblMaybeLater]}>
        {promotion.maybe_later}
      </Text>
      {!(simPlatform === Android) && <View style={myStyles.lblBottomLine} />}
      {simPlatform !== Android && withStatusBar
            && (
            <View style={myStyles.imageStatusBar}>
              <Image
                fadeDuration={0}
                style={myStyles.scr_status_Bar_Ios_Style}
                source={img_scr_status_Bar_Ios}
              />
            </View>
            )}
    </View>
  );
};
export default FullPageSpecialSimulator;
